import React from 'react';
import RoleForm from './RoleForm';
import StandardModal from '../../Shared/UI/StandardModal/components/StandardModal';
import { useRoleShowState, useRoleShowActions } from './RoleShowContext';
import { updateRole } from './restApi';

import styles from './RoleModal.module.scss';

const RoleEditModal = () => {
  const state = useRoleShowState();
  const { closeRoleEditModal, onResponse, onError } = useRoleShowActions();

  return (
    <StandardModal
      isOpen={state?.roleEditModalIsOpen}
      onRequestClose={() => {
        closeRoleEditModal();
      }}
    >
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>
          Update Role
        </h2>
        <RoleForm
          role={state?.role}
          onSubmit={(args) => {
            updateRole({
              ...args,
              onResponse,
              onError,
            });
          }}
          onCancel={closeRoleEditModal}
        />
      </section>
    </StandardModal>
  );
};

export default RoleEditModal;
